import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveProjectRequestFailure(project) {
      const state = getState().find(
        ({ project: { uuid } }) => uuid === project.uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isRemoveProjectRequestPending(project) {
      const state = getState().find(
        ({ project: { uuid } }) => uuid === project.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isRemoveProjectRequestSuccess(project) {
      const state = getState().find(
        ({ project: { uuid } }) => uuid === project.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
